import { zVerificationListForResidenceData } from '@repo/sdk/zod'
import { createFileRoute, redirect } from '@tanstack/react-router'
import { z } from 'zod'

const filters = zVerificationListForResidenceData.shape.body.shape.filters.shape

const searchSchema = z.object({
	state: filters.state.catch(undefined),
	search: filters.search.catch(undefined)
})

/**
 * The verifications have no list of their own: they are on the page of the
 * assignees, "Ingressi". This sends an old link or bookmark there, with its
 * filters.
 */
export const Route = createFileRoute(
	'/(private)/bando/$residenceId/verifiche/'
)({
	validateSearch: searchSchema,
	beforeLoad: ({ params, search }) => {
		throw redirect({
			to: '/bando/$residenceId/ingressi',
			params,
			search: { verification: search.state, search: search.search },
			replace: true
		})
	}
})
